import { render, staticRenderFns } from "./CalendarPublicHolidayGroups.vue?vue&type=template&id=39281f0b&"
import script from "./CalendarPublicHolidayGroups.vue?vue&type=script&lang=js&"
export * from "./CalendarPublicHolidayGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports